import http from '@services/http'
import { IAssets, ICashHistory, IHeartHistory, IHistory, IItemHistory, IMoneyHistory } from '@protocol/bank'
import { PROPERTY_ID } from 'adv-protocol/src/GameCommon'

export default {
  getAssets(data: IAssets.Params): Promise<IAssets.Schema> {
    return http.get('bank/assets', data || {})
  },

  getMoneyHistory(data: IMoneyHistory.Params): Promise<IMoneyHistory.Schema> {
    return http.post('bank/moneyHistory', data || {})
  },

  getCashHistory(data: ICashHistory.Params): Promise<ICashHistory.Schema> {
    return http.post('bank/cashHistory', data || {})
  },

  getHeartHistory(data: IHeartHistory.Params): Promise<IHeartHistory.Schema> {
    return http.post('bank/heartHistory', data || {})
  },

  getItemHistoryList(data: IItemHistory.Params): Promise<IItemHistory.Schema> {
    return http.get('bank/itemHistoryList', data || {})
  },

  getHistoryList(data: IHistory.Params, propertyType: PROPERTY_ID): Promise<IHistory.Schema> {
    switch (propertyType) {
      case PROPERTY_ID.MONEY:
        return this.getMoneyHistory(data)
      case PROPERTY_ID.HEART:
        return this.getHeartHistory(data)
      case PROPERTY_ID.CASH:
        return this.getCashHistory(data)
      default:
        return this.getItemHistoryList(data)
    }
  },
}
